import { render, staticRenderFns } from "./StatusRightsManager.vue?vue&type=template&id=6c9017bf&scoped=true&"
import script from "./StatusRightsManager.vue?vue&type=script&lang=js&"
export * from "./StatusRightsManager.vue?vue&type=script&lang=js&"
import style0 from "./StatusRightsManager.vue?vue&type=style&index=0&id=6c9017bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9017bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout,VSelect})
